import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { formatAmount } from 'vopay';
import { TransactionDetailsCard } from 'UI';

type ErrorInfoCardProps = {
  currency: string;
  amount: string;
  lastModified: string;
  failureReason: string;
};

const ErrorInfoCard: FC<ErrorInfoCardProps> = ({ currency, amount, lastModified, failureReason }) => {
  const { t } = useTranslation('translations', {
    keyPrefix: 'Transaction.Details.TransactionDetails',
  });

  if (!failureReason) return null;

  const errorDetails = [
    {
      label: t('Label.failureDateTime', { defaultValue: 'Failure Date Time' }),
      value: lastModified || '-',
    },
    {
      label: t('Label.amount', { defaultValue: 'Amount' }),
      value: `${currency} ${formatAmount(amount)}`,
    },
    {
      label: t('Label.failureReason', { defaultValue: 'Failure Reason' }),
      value: failureReason || '-',
    },
  ];

  return <TransactionDetailsCard title={t('Title.errorInfo', { defaultValue: 'Error Info' })} details={errorDetails} />;
};

export default ErrorInfoCard;
